import { render, staticRenderFns } from "./AlarmsButton.vue?vue&type=template&id=444727f5&"
import script from "./AlarmsButton.vue?vue&type=script&lang=js&"
export * from "./AlarmsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports